import { jsx as _jsx } from "react/jsx-runtime";
import { DividerSizes, DividerVariants, DividerWeights, } from "./constants";
import StyledDivider from "./Divider.style";
const Divider = ({ variant = DividerVariants.primary, size = DividerSizes.soft, weight = DividerWeights.regular, ...props }) => (_jsx(StyledDivider, { variant: variant, size: size, weight: weight, ...props }));
export default Divider;
//# sourceMappingURL=Divider.js.map